// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3bW1B","info":"Note_info__2I9WC","note":"Note_note__1tj5X","actions":"Note_actions__3F4rg"};